module.exports = __webpack_public_path__ + "img/france.d1a54169.svg";